import palette from 'lib/styles/palette';
import { toast } from 'react-hot-toast';
import { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { validatePassword } from 'utils/validate';
import { useMutation } from 'react-query';
import { updatePassword } from 'lib/api/service/users';
import { useParams, useNavigate } from 'react-router-dom';
import useLoginCheck from 'hooks/common/useLoginCheck';
import { useSelector } from 'react-redux';

const ResetPasswordPage = () => {
  const navigate = useNavigate();
  const { id, level, type } = useParams();
  const [passwordForm, setPasswordForm] = useState({
    password: '',
    passwordConfirm: '',
  });
  const [isSubmit, setIsSubmit] = useState(false);
  const [localErrors, setLocalErrors] = useState({});
  const [error, setErrors] = useState('');
  const { accessToken } = useSelector(({ auth }) => auth);

  const updatePasswordMutation = useMutation(updatePassword, {
    onError: data => {
      if (data.response.status === 500) {
        setErrors('서버 오류로 비밀번호 재설정에 실패했습니다');
      }
    },
    onSuccess: () => {
      toast.success('비밀번호가 성공적으로 재설정되었습니다!');
      navigate('/');
    },
  });

  useLoginCheck(updatePasswordMutation.error?.response, () => {
    updatePasswordMutation.mutate({
      id,
      password: passwordForm.password,
      level,
      type,
    });
  });

  useEffect(() => {
    if (isSubmit && Object.keys(localErrors).length === 0) {
      setIsSubmit(false);
      updatePasswordMutation.mutate({
        id,
        password: passwordForm.password,
        level,
        type,
      });
    }
  }, [
    isSubmit,
    localErrors,
    updatePasswordMutation,
    id,
    passwordForm.password,
    level,
    type,
  ]);

  const onSubmit = e => {
    e.preventDefault();
    setLocalErrors(
      validatePassword(passwordForm.password, passwordForm.passwordConfirm),
    );
    setIsSubmit(true);
  };

  const onChange = e => {
    const { name, value } = e.target;
    setPasswordForm({
      ...passwordForm,
      [name]: value,
    });
  };

  useEffect(() => {
    if (!accessToken) {
      navigate('/');
    }
  }, [accessToken, navigate]);

  return (
    <ResetPasswordPageBlock>
      <Box>
        <div className="logo">비밀번호 재설정</div>
        <form>
          <StyledInput
            type="password"
            placeholder="비밀번호"
            autoFocus
            name="password"
            value={passwordForm.password}
            onChange={onChange}
          />
          {localErrors.password && (
            <ErrorMessage>{localErrors.password}</ErrorMessage>
          )}
          <StyledInput
            type="password"
            placeholder="비밀번호 재확인"
            name="passwordConfirm"
            value={passwordForm.passwordConfirm}
            onChange={onChange}
          />
          {localErrors.passwordConfirm && (
            <ErrorMessage>{localErrors.passwordConfirm}</ErrorMessage>
          )}
          {error && <ErrorMessage server>{error}</ErrorMessage>}
          <StyledBtn onClick={onSubmit}>확인</StyledBtn>
        </form>
      </Box>
    </ResetPasswordPageBlock>
  );
};

export default ResetPasswordPage;

const ResetPasswordPageBlock = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${palette.background};
`;

const Box = styled.div`
  width: 500px;
  padding-bottom: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: solid 1px rgba(0, 0, 0, 0.08);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.5);
  box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.04);

  .logo {
    font-size: 1.5rem;
    margin: 2rem 0;
    color: ${palette.theme[3]};
    font-weight: 600;
    letter-spacing: 5px;
  }

  form {
    display: flex;
    flex-direction: column;
  }
`;

const StyledInput = styled.input`
  width: 330px;
  height: 50px;
  padding: 15px;
  border: solid 1px #dfdfdf;
  border-radius: 11px;
  background: #fff;
  font-size: 16px;
  &::placeholder {
    color: #c6c6c6;
  }
  & + & {
    margin-top: 15px;
  }
`;

const ErrorMessage = styled.div`
  margin-left: 10px;
  padding: 0.5rem 0;
  display: flex;
  color: red;
  font-size: 12px;
  font-weight: 500;

  ${props =>
    props.server &&
    css`
      justify-content: center;
      margin-top: 1rem;
    `}
`;

const StyledBtn = styled.button`
  width: 330px;
  height: 50px;
  margin-top: 15px;
  border: none;
  border-radius: 11px;
  background: ${palette.theme[3]};
  color: white;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  &:hover {
    background: ${palette.theme[2]};
  }
`;
